import Logo from '@/app/shared/common/Logo';
import { FooterLogoText } from '@/types/types';

interface FooterLogoProps {
  logoData?: FooterLogoText;
}

export default function FooterLogo({ logoData }: FooterLogoProps) {
  const defaultText =
    "Envision is an award-winning design-build agency and a market leader in digital recognition walls with over twenty years' experience in completing award-winning installations for major brands across North America.";

  return (
    <div className='flex flex-col phone:mx-auto phone:items-center  table:mx-auto  text-gray-300 max-w-[330px] phone:w-full'>
      <Logo />
      <p className='mt-6 max-w-[330px] phone:text-center leading-relaxed text-gray-300'>
        {logoData?.text || defaultText}
      </p>
    </div>
  );
}
